<template>
  <div v-show="facet.data.length" class="search-facet--checkbox">
    <label
      v-for="facetItem in facet.data"
      v-show="facet.data.length"
      :key="getValue(facetItem, facet.type)"
      class="search-facet--checkbox-label"
    >
      <input
        class="search-facet--checkbox-input"
        type="checkbox"
        :value="getValue(facetItem, facet.type)"
        :checked="isChecked(getValue(facetItem, facet.type))"
        @change="$emit('change', $event)"
      />
      <span :class="{'small': !isTabletOrSmaller}">{{ getValue(facetItem, facet.type) }}</span>
      <span :class="{'small': !isTabletOrSmaller}">{{ facetItem.count }}</span>
    </label>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  facet: {
    type: Object,
    required: true
  },
  checked: {
    type: Array,
    required: true
  }
})
const emit = defineEmits(['change'])

// check screen size
let isTabletOrSmaller = ref(window.innerWidth <= 1200);
const updateViewport = () => {
  isTabletOrSmaller.value = window.innerWidth <= 1200;
};

function isChecked(value) {
  return props.checked && props.checked.includes(value)
}

function getValue(facetItem, type) {
  return type === "range" ? facetItem.value.name : facetItem.value;
}
</script>